import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream-100">
                <div className="w-10 h-10 rounded-full border-4 border-cream-300 border-t-coral animate-spin"/>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }}/>;
    return children;
};
